<template>
  <div
    class="flex justify-center items-start gap-1 rounded-lg border border-solid w-full border-surface-200 shadow-sm bg-white hover:border-surface-400 focus-within:border-primary-500 focus-within:hover:border-primary-500 focus-within:ring-1 focus-within:ring-primary-300/50 focus-within:shadow-none duration-300 ease-out px-3 py-2"
    :class="{
      '!border-error-400 focus-within:!ring-error-300/50':
        validationMessage && touched,
    }"
  >
    <textarea
      :id="id"
      ref="textareaRef"
      v-model="modelValue"
      type="text"
      :name="name"
      :placeholder="placeholder"
      :rows="rows"
      :maxlength="maxlength"
      class="w-full text-xs font-medium min-h-11 bg-transparent outline-none placeholder:text-gray-400 resize-none grow"
    />

    <!-- INVALID ICON -->
    <div
      v-if="validationMessage && touched"
      v-tooltip="validationMessage"
      class="h-4 w-4 flex items-center justify-center shrink-0 duration-150 text-error-500"
    >
      <AppIcon
        icon="fa-solid fa-circle-exclamation"
        class="text-xs"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const modelValue = defineModel<string>({ required: true })

const textareaRef = ref<HTMLTextAreaElement | null>(null)

/**
 * Focus the inner textarea, caret at the end.
 *
 * Additive, for a consumer that swaps this in place of a read view and has to
 * move focus into it — the root is a plain `<div>`, so the component itself is
 * not focusable and nothing here was reachable from outside.
 */
defineExpose({
  focus() {
    const element = textareaRef.value
    if (!element) return
    element.focus()
    element.setSelectionRange(element.value.length, element.value.length)
  },
})

defineProps({
  name: {
    type: String,
    required: false,
    default: undefined,
  },
  id: {
    type: String,
    required: false,
    default: undefined,
  },
  placeholder: {
    type: String,
    required: false,
    default: undefined,
  },
  rows: {
    type: Number,
    required: false,
    default: 5,
  },
  validationMessage: {
    type: String,
    required: false,
    default: undefined,
  },
  touched: {
    type: Boolean,
    required: false,
    default: true,
  },
  maxlength: {
    type: Number,
    required: false,
    default: undefined,
  },
})
</script>
